import {ChangeDetectionStrategy, Component, HostBinding, Input} from "@angular/core";
import {FUIAbstractLabel} from "../abstract-label";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-message-label",
    styleUrls: ["./message-label.component.scss"],
    templateUrl: "./message-label.component.html"
})
export class FUIMessageLabelComponent extends FUIAbstractLabel {
    @HostBinding("class.clickable") @Input() clickable: boolean = false;
}
